export default __webpack_public_path__ + "static/media/info.eef102b6.svg";